/**
 * Ladder Locker FAQ — topic nav, mobile dropdown, search filter
 */
(function () {
  function initFaq() {
    var section = document.querySelector('.ll-faq-topics');
    if (!section) return;

    var topics = Array.prototype.slice.call(section.querySelectorAll('[data-ll-faq-topic]'));
    var navLinks = Array.prototype.slice.call(section.querySelectorAll('[data-ll-faq-nav]'));
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-ll-faq-item]'));
    var empty = section.querySelector('.ll-faq-topics__empty');
    var dropdown = section.querySelector('.ll-faq-topics__dropdown');
    var toggle = section.querySelector('.js-ll-faq-dd-toggle');
    var label = section.querySelector('.js-ll-faq-dd-label');
    var isMobile = function () {
      return window.matchMedia('(max-width: 989px)').matches;
    };
    var userPickedUntil = 0;

    function setDropdownOpen(open) {
      if (!dropdown || !toggle) return;
      dropdown.classList.toggle('is-open', !!open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function setActive(id) {
      if (!id) return;
      var activeLink = null;

      navLinks.forEach(function (link) {
        var on = link.getAttribute('data-ll-faq-nav') === id;
        link.classList.toggle('is-active', on);
        if (on) {
          link.setAttribute('aria-current', 'true');
          activeLink = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });

      if (activeLink && label) {
        var name =
          activeLink.getAttribute('data-ll-faq-nav-label') ||
          (activeLink.querySelector('.ll-faq-topics__nav-title') || {}).textContent ||
          activeLink.textContent;
        label.textContent = String(name).replace('→', '').trim();
      }
    }

    /* Measure whatever is currently covering the top of the screen */
    function stickyTopCover() {
      var cover = 0;
      var selectors = [
        '.shopify-section-group-header-group',
        '.announcement-bar-section',
        '.section-header',
        'sticky-header',
        '.header-wrapper',
        '#shopify-section-header'
      ];

      selectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.height <= 0) return;
          /* Overlaps the top band of the viewport */
          if (r.top <= 1 && r.bottom > 0) {
            cover = Math.max(cover, r.bottom);
          }
        });
      });

      var cssHeader = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      );
      if (!isNaN(cssHeader)) cover = Math.max(cover, cssHeader);

      return Math.max(Math.ceil(cover), 100) + 24;
    }

    function scrollToTopic(target) {
      if (!target) return;

      var run = function () {
        var offset = stickyTopCover();
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });

        /* After smooth scroll, nudge if title still sits under header */
        window.setTimeout(function () {
          var need = stickyTopCover();
          var top = target.getBoundingClientRect().top;
          if (top < need) {
            window.scrollBy({ top: top - need, behavior: 'auto' });
          }
        }, 450);
      };

      /* Wait a frame so dropdown close doesn’t affect measurements */
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
      });
    }

    function pickTopic(id, scroll) {
      if (!id) return;
      userPickedUntil = Date.now() + 2500;
      setActive(id);
      setDropdownOpen(false);

      if (scroll) {
        var target = section.querySelector('[data-ll-faq-topic="' + id + '"]');
        scrollToTopic(target);
        try {
          history.replaceState(null, '', '#faq-' + id);
        } catch (e) {}
      }
    }

    /* Mobile dropdown toggle */
    if (toggle && dropdown && !toggle.dataset.llFaqBound) {
      toggle.dataset.llFaqBound = '1';
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setDropdownOpen(!dropdown.classList.contains('is-open'));
      });
    }

    /* Outside click closes dropdown */
    if (dropdown && !dropdown.dataset.llFaqOutside) {
      dropdown.dataset.llFaqOutside = '1';
      document.addEventListener('click', function (event) {
        if (!dropdown.classList.contains('is-open')) return;
        if (dropdown.contains(event.target)) return;
        setDropdownOpen(false);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setDropdownOpen(false);
      });
    }

    /* Topic clicks — event delegation (works for mobile + desktop) */
    if (dropdown && !dropdown.dataset.llFaqNav) {
      dropdown.dataset.llFaqNav = '1';
      dropdown.addEventListener('click', function (event) {
        var link = event.target.closest('[data-ll-faq-nav]');
        if (!link || !dropdown.contains(link)) return;

        event.preventDefault();
        event.stopPropagation();

        var id = link.getAttribute('data-ll-faq-nav');
        pickTopic(id, true);
      });
    }

    /* If page opens with a topic hash, clear header overlap */
    if (!section.dataset.llFaqHash) {
      section.dataset.llFaqHash = '1';
      var hash = (window.location.hash || '').replace(/^#/, '');
      if (hash.indexOf('faq-') === 0) {
        var hashId = hash.replace(/^faq-/, '');
        var hashTarget = section.querySelector('[data-ll-faq-topic="' + hashId + '"]');
        if (hashTarget) {
          setActive(hashId);
          window.setTimeout(function () {
            scrollToTopic(hashTarget);
          }, 50);
        }
      }
    }

    /* Scroll spy — desktop only; skip shortly after a manual pick */
    if ('IntersectionObserver' in window && topics.length && !section.dataset.llFaqIo) {
      section.dataset.llFaqIo = '1';
      var io = new IntersectionObserver(
        function (entries) {
          if (Date.now() < userPickedUntil) return;
          if (isMobile()) return;

          var visible = entries
            .filter(function (entry) {
              return entry.isIntersecting;
            })
            .sort(function (a, b) {
              return b.intersectionRatio - a.intersectionRatio;
            });

          if (!visible.length) return;
          var id = visible[0].target.getAttribute('data-ll-faq-topic');
          if (id) setActive(id);
        },
        { rootMargin: '-20% 0px -55% 0px', threshold: [0, 0.25, 0.5] }
      );
      topics.forEach(function (topic) {
        io.observe(topic);
      });
    }

    function filter(query) {
      var q = (query || '').trim().toLowerCase();
      var visibleCount = 0;

      items.forEach(function (item) {
        var hay = (item.getAttribute('data-ll-faq-text') || '').toLowerCase();
        var show = !q || hay.indexOf(q) !== -1;
        item.hidden = !show;
        if (show) visibleCount += 1;
        if (show && q) {
          var details = item.querySelector('details');
          if (details) details.open = true;
        }
      });

      topics.forEach(function (topic) {
        var any = topic.querySelector('[data-ll-faq-item]:not([hidden])');
        topic.hidden = !any;
      });

      if (empty) empty.hidden = visibleCount > 0;
    }

    document.querySelectorAll('.js-ll-faq-search').forEach(function (input) {
      if (input.dataset.llFaqBound) return;
      input.dataset.llFaqBound = '1';
      input.addEventListener('input', function () {
        filter(input.value);
      });
    });
  }

  function boot() {
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    var section = document.querySelector('.ll-faq-topics');
    if (section) {
      delete section.dataset.llFaqIo;
      delete section.dataset.llFaqHash;
      var dropdown = section.querySelector('.ll-faq-topics__dropdown');
      var toggle = section.querySelector('.js-ll-faq-dd-toggle');
      if (dropdown) {
        delete dropdown.dataset.llFaqOutside;
        delete dropdown.dataset.llFaqNav;
      }
      if (toggle) delete toggle.dataset.llFaqBound;
    }
    boot();
  });
})();
